import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import piHomeCard from "../pi-home-card/pi-home-card.vue";
import statisticsEcharts from "@/components/pi-statistics-echarts/pi-statistics-echarts.vue";
import { getHomeStatGunStatus } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
let PiHomeChargeIncome = class PiHomeChargeIncome extends Vue {
    constructor() {
        super(...arguments);
        this.configData = {
            type: "pic",
            picType: "full",
            legendValue: true,
        };
        this.option = {
            title: {
                subtext: i18n.t("home.gunTotal"),
            },
            legend: {
                itemGap: 10,
                textStyle: {
                    rich: {
                        //名称长度
                        a: {
                            width: 70,
                        },
                    },
                },
            },
            series: [
                {
                    data: [],
                },
            ],
            color: [
                "#FFDC84",
                "#53C1FF",
                "#DE672F",
                "#F7B6B2",
                "#D9DADC",
                "#7AE795",
                "#4D80B7",
                "#18CFDB",
            ],
        };
        this.timeType = "1";
    }
    /**
     * 获取充电枪状态，并组合成图表的样式
     */
    async getHomeStatGunStatus() {
        const ret = await getHomeStatGunStatus({});
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data || [];
            this.option.series[0].data = data;
        }
    }
    mounted() {
        this.getHomeStatGunStatus();
    }
};
__decorate([
    Prop({ default: false })
], PiHomeChargeIncome.prototype, "isEchart", void 0);
PiHomeChargeIncome = __decorate([
    Component({
        components: {
            "pi-home-card": piHomeCard,
            "pi-statistics-echarts": statisticsEcharts,
        },
    })
], PiHomeChargeIncome);
export default PiHomeChargeIncome;
